import { RequestOptions } from './interfaces';

export const DEFAULT_REQUEST_HEADERS = {
    ACCEPT: {
        'accept': 'application/json',
    },
    CONTENT_TYPE: {
        'content-type': 'application/json',
    },
};

export const DEFAULT_REQUEST_INIT: Record<'GET' | 'POST', RequestOptions> = {
    GET: {
        method: 'GET',
        headers: DEFAULT_REQUEST_HEADERS.ACCEPT,
    },
    POST: {
        method: 'POST',
        headers: {
            ...DEFAULT_REQUEST_HEADERS.ACCEPT,
            ...DEFAULT_REQUEST_HEADERS.CONTENT_TYPE,
        },
    },
};
